import React from 'react'
const Overlay = function(){
    return (<div id="overlay"></div>)
}
export {Overlay}